<template>
  <sc-provider>
    <router-view />
  </sc-provider>
</template>

<script lang="ts" setup></script>
<style lang="scss">
#app {
  height: 100%;
}
</style>
